


















import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class InstallPromptCard extends Vue {
    @Prop({required: true}) title!: string;
    @Prop({required: true}) description!: string;
    @Prop({required: true}) buttonLabel!: string;
    @Prop({required: true}) accentColor!: string;
    @Prop({default: ""}) hint!: string;
}
